import { Snackbar, styled } from '@mui/material';

export const StyledBaseSnackbar = styled(Snackbar)(({ theme }) => ({
  top: '72px',
  right: '16px',
  left: 'auto',
  '& .MuiSnackbarContent-root': {
    minWidth: '300px',
    color: theme.palette.grey[800],
    backgroundColor: theme.palette.grey[100],
  },
}));
